<template>
  <v-container>
    <v-timeline>
      <v-timeline-item v-for="(year, i) in years" :color="year.color" :key="i" small>
        <span
          slot="opposite"
          :class="`headline font-weight-bold ${year.color}--text`"
          v-text="year.year"
        ></span>
        <div class="py-3">
          <h2 :class="`headline font-weight-light mb-3 ${year.color}--text`" v-text="year.title"></h2>
          <h3 :class="`subheading font-weight-light mb-3 ${year.color}--text`" v-html="`Zakładana faza: ${year.phase}`"></h3>
          <div v-html="year.desc"></div>
        </div>
      </v-timeline-item>
    </v-timeline>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    years: [
      {
        color: "blue-grey",
        phase: "Prototyp",
        year: "koniec stycznia 2019",
        title: "Pierwsze widoki",
        desc: "<p>Aplikacja mobilna do podglądu swoich ćwiczeń ma już pierwsze statyczne widoki- formularz logowania, rejestrację, reset hasła, widok po zalogowaniu.</p>"
      },
      {
        color: "blue-grey",
        phase: "Prototyp",
        year: "koniec kwietnia 2019",
        title: "Główne widoki",
        desc: "<p>Zrealizowane główne widoki dla przykładowego użytkownika</p><p>Dane być może przypisane na sztywno do JSON'a</p><p>Widoki w wersji podstawowej, bez zaawansowanych animacji</p>"
      },
      {
        color: "blue-grey",
        phase: "Prototyp",
        year: "koniec maja 2019",
        title: "Panel użytkownika",
        desc: "<p>Stworzony panel użytkownika, który zaciąga dane z pliku JSON.</p>"
      },
      {
        color: "blue-grey",
        phase: "Prototyp",
        year: "koniec czerwca/lipca 2019",
        title: "Aplikacja ma dopisane akcje na wszelkich buttonach",
        desc: "<p>Aplikacja posiada zapisane skrypty interakcyjne (prowadzace na backend) jak np. zapisywanie danych usera</p>"
      },
      {
        color: "blue-grey",
        phase: "Prototyp",
        year: "koniec sierpnia 2019",
        title: "Aplikacja umie uwierzytelniać i wystawiać dane użytkownika",
        desc: "<p>Aplikacja odróżnia usera zalogowanego i niezalogowanego, przedstawiając dla obu określoną zawartość.</p><p>Użytkownik niezalogowany dostaje błąd gdy znajduje się na stronie dla niego niedostępnej.</p><p>Manualna możliwość nadpisania tego warunku (wszystkie dane dla kogokolwiek) w celach developerskich</p><p>Ponadto użytkownik powinien być zapamiętany na jakiś czas, by nie musiał logować się co 5 minut...</p>"
      },
      {
        color: "blue-grey",
        phase: "Prototyp",
        year: "wrzesień 2019",
        title: "Prototyp jest gotowy",
        desc: "Aplikacja w wersji podstawowej jest stworzona, możliwa do testowania na siłowniach."
      }
    ]
  })
};
</script>

<style>
</style>
